import React, { useState } from "react"
import { NavLink, Outlet } from "react-router-dom"
import IconsColor from "util/iconsColor"
import styles from "component/configuration/configuration.module.scss"

const Configuration: React.FC = () => {
    const [collapsed, setCollapsed] = useState(false)

    return (
        <div className={styles.shell}>
            <aside className={`${styles.sidebar} ${collapsed ? styles.sidebarCollapsed : ""}`}>
                <div className={styles.sidebarHeader}>
                    {!collapsed && <p className={styles.sidebarTitle}>CONFIGURATION</p>}
                    <button
                        type="button"
                        className={styles.sidebarToggle}
                        onClick={() => setCollapsed((prev) => !prev)}
                        aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
                    >
                        <IconsColor
                            iconName={collapsed ? "chevronRight" : "chevronLeft"}
                            width="16"
                            height="16"
                            fillColor="none"
                            strokeColor="currentColor"
                        />
                    </button>
                </div>
                <nav className={styles.sidebarNav}>
                    <NavLink
                        to="/configuration/users"
                        className={({ isActive }) =>
                            `${styles.sidebarItem} ${isActive ? styles.sidebarItemActive : ""}`
                        }
                        title={collapsed ? "User Management" : undefined}
                    >
                        <span className={styles.sidebarIcon}>
                            <IconsColor iconName="personIcon" width="18" height="18" fillColor="none" strokeColor="currentColor" />
                        </span>
                        {!collapsed && "User Management"}
                    </NavLink>
                    <NavLink
                        to="/configuration/cities"
                        className={({ isActive }) =>
                            `${styles.sidebarItem} ${isActive ? styles.sidebarItemActive : ""}`
                        }
                        title={collapsed ? "Cities" : undefined}
                    >
                        <span className={styles.sidebarIcon}>
                            <IconsColor iconName="location" width="18" height="18" fillColor="none" strokeColor="currentColor" />
                        </span>
                        {!collapsed && "Cities"}
                    </NavLink>
                </nav>
            </aside>
            <div className={styles.main}>
                <Outlet />
            </div>
        </div>
    )
}

export default Configuration
